import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
class DiagramDosenTidakTetap extends Component {
    
    options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
    }
    render(){
        // console.log("data =", this.props.dataDosen)
        let jumlah = this.props.dataDosen?.data_dosen_ikatan || {};
        let i =0;
        let year = [];
        let lainnya = [];
        let profesi = [];
        let s1 = [];
        let s2 = [];
        let s3 = [];
        let sp_1 = [];
        let sp_2 = [];
        let tanpa_jenjang = [];
        for(var key in jumlah){
            year[i] = key;
            if(jumlah[key]?.dosen_tidak_tetap?.lainnya !== undefined){
                lainnya[i] = jumlah[key]?.dosen_tidak_tetap?.lainnya;
            }else{
                lainnya[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap?.profesi !== undefined){
                profesi[i] = jumlah[key]?.dosen_tidak_tetap?.profesi;
            }else{
                profesi[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap?.s1 !== undefined){
                s1[i] = jumlah[key]?.dosen_tidak_tetap?.s1;
            }else{
                s1[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap.s2 !== undefined){
                s2[i] = jumlah[key]?.dosen_tidak_tetap?.s2;
            }else{
                s2[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap?.s3 !== undefined){
                s3[i] = jumlah[key]?.dosen_tidak_tetap?.s3;
            }else{
                s3[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap["sp-1"] !== undefined){
                sp_1[i] = jumlah[key]?.dosen_tidak_tetap["sp-1"];
            }else{
                sp_1[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap["sp-2"] !== undefined){
                sp_2[i] = jumlah[key]?.dosen_tidak_tetap["sp-2"];
            }else{
                sp_2[i] = 0;
            }
            if(jumlah[key]?.dosen_tidak_tetap?.tanpa_jenjang !== undefined){
                tanpa_jenjang[i] = jumlah[key]?.dosen_tidak_tetap?.tanpa_jenjang;
            }else{
                tanpa_jenjang[i] = 0;
            }
            i++;
        }
        // console.log("tanpa_jenjang=", tanpa_jenjang)
        let data_dosenTetap = {
            labels: year,
            datasets: [
                  {
                    label: 'Lainnya',
                    // stack: 'stack1',
                    backgroundColor: '#6e7b8f',
                    borderColor: '#6e7b8f',
                    borderWidth: 1,
                    hoverBackgroundColor: '#6e7b8f',
                    hoverBorderColor: '#6e7b8f',
                    data: lainnya,
                },
                {
                    label: 'SP-2',
                    // stack: 'stack1',
                    backgroundColor: '#50b4d8',
                    borderColor: '#50b4d8',
                    borderWidth: 1,
                    hoverBackgroundColor: '#50b4d8',
                    hoverBorderColor: '#50b4d8',
                    data: sp_2,
                },
                {
                label: 'Sp-1',
                // stack: 'stack1',
                backgroundColor: '#9eddef',
                borderColor: '#9eddef',
                borderWidth: 1,
                hoverBackgroundColor: '#9eddef',
                hoverBorderColor: '#9eddef',
                data: sp_1,
                },
                  {
                    label: 'S1',
                    // stack: 'stack1',
                    backgroundColor: '#cab3c1',
                    borderColor: '#cab3c1',
                    borderWidth: 1,
                    hoverBackgroundColor: '#cab3c1',
                    hoverBorderColor: '#cab3c1',
                    data: s1,
                    },
                {
                    label: 'Profesi',
                    // stack: 'stack1',
                    backgroundColor: '#f7e5b7',
                    borderColor: '#f7e5b7',
                    borderWidth: 1,
                    hoverBackgroundColor: '#f7e5b7',
                    hoverBorderColor: '#f7e5b7',
                    data: profesi,
                },
                {
                    label: 'S2',
                    // stack: 'stack1',
                    backgroundColor: '#d7e2ea',
                    borderColor: '#d7e2ea',
                    borderWidth: 1,
                    hoverBackgroundColor: '#d7e2ea',
                    hoverBorderColor: '#d7e2ea',
                    data: s2,
                },
                {
                    label: 'S3',
                    // stack: 'stack1',
                    backgroundColor: '#a7d9c9',
                    borderColor: '#a7d9c9',
                    borderWidth: 1,
                    hoverBackgroundColor: '#a7d9c9',
                    hoverBorderColor: '#a7d9c9',
                    data: s3,
                }, 
                {
                  label: 'Tanpa Jenjang',
                  // stack: 'stack1',
                  backgroundColor: '#b2e8eb',
                  borderColor: '#b2e8eb',
                  borderWidth: 1,
                  hoverBackgroundColor: '#b2e8eb',
                  hoverBorderColor: '#b2e8eb',
                  data: tanpa_jenjang,
              },
                
            ],
          };
        return(
            <>
            <div className={`card-custom`}>
                {/* Header */}
                <div className="card-header border-0" style={{textAlign:'center', paddingBottom: "0px"}}>
                    <h5 className="card-title font-weight-bolder" style={{color:'#354f7a'}}>
                        Dosen Tidak Tetap Berdasarkan Program Pendidikan
                    </h5>
                </div>

                {/* Body */}
                <div className="card-body pt-2">
                    <Bar data={data_dosenTetap} options={this.options} />
                </div>
            </div>
            </>
        )
    }
}
export default DiagramDosenTidakTetap;